var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.84375C4.71875 1.84375 2.09375 4.49609 2.09375 7.75C2.09375 11.0312 4.71875 13.6562 8 13.6562C11.2539 13.6562 13.9062 11.0312 13.9062 7.75C13.9062 4.49609 11.2266 1.84375 8 1.84375ZM8 0.96875C11.7188 0.96875 14.7812 4.03125 14.7812 7.75C14.7812 11.4961 11.7188 14.5312 8 14.5312C4.25391 14.5312 1.21875 11.4961 1.21875 7.75C1.21875 4.03125 4.25391 0.96875 8 0.96875ZM7.67188 4.25H8.30078C8.49219 4.25 8.62891 4.41406 8.62891 4.60547L8.4375 9.19922C8.4375 9.36328 8.27344 9.5 8.10938 9.5H7.86328C7.69922 9.5 7.53516 9.36328 7.53516 9.19922L7.34375 4.60547C7.34375 4.41406 7.48047 4.25 7.67188 4.25ZM8 10.0469C8.41016 10.0469 8.76562 10.4023 8.76562 10.8125C8.76562 11.25 8.41016 11.5781 8 11.5781C7.5625 11.5781 7.23438 11.25 7.23438 10.8125C7.23438 10.4023 7.5625 10.0469 8 10.0469Z"
  })));
};
export default __webpack_public_path__ + "assets/70c826461d9af71a1a137c7a20a42c2a.svg";
export { SvgAlert as ReactComponent };


// WEBPACK FOOTER //
// ./components/messages/icons/alert.svg